module.exports = __webpack_public_path__ + "img/9_32.884a8fd9.png";